//Constantes de cod_empresa para customizações
export const SAO_CAMILO = 571;
export const UNISC = 87;
export const CJF = 523;
export const UFPEL = 362;
export const FAAP = 189;
export const USIMINAS = 377;
